(() => {
  const root = document.querySelector('.sp-page');
  if (!root) return;

  const ugcFrames = [...root.querySelectorAll('.sp-video-frame')];
  ugcFrames.forEach((frame) => {
    const video = frame.querySelector('video');
    const button = frame.querySelector('button');
    const toggle = () => {
      ugcFrames.forEach((other) => {
        const otherVideo = other.querySelector('video');
        if (other !== frame) {
          otherVideo.pause();
          other.classList.remove('is-playing');
          const otherButton = other.querySelector('button');
          otherButton.querySelector('span').textContent = '▶';
          otherButton.setAttribute('aria-label', otherButton.getAttribute('aria-label').replace('Pause', 'Play'));
        }
      });
      if (video.paused) video.play(); else video.pause();
    };
    button.addEventListener('click', toggle);
    video.addEventListener('click', toggle);
    video.addEventListener('play', () => {
      frame.classList.add('is-playing');
      button.querySelector('span').textContent = 'Ⅱ';
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Play', 'Pause'));
    });
    const reset = () => {
      frame.classList.remove('is-playing');
      button.querySelector('span').textContent = '▶';
      button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Pause', 'Play'));
    };
    video.addEventListener('pause', reset);
    video.addEventListener('ended', reset);
  });

  const ritual = root.querySelector('.sp-phone-video');
  if (ritual) {
    const video = ritual.querySelector('video');
    const endCard = ritual.querySelector('.sp-end-card');
    const play = ritual.querySelector('[data-action="play"]');
    const mute = ritual.querySelector('[data-action="mute"]');
    const slider = ritual.querySelector('input[type="range"]');
    const current = ritual.querySelector('[data-time="current"]');
    const duration = ritual.querySelector('[data-time="duration"]');
    const time = (value) => `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}`;
    const update = () => {
      slider.max = Number.isFinite(video.duration) ? video.duration : 0;
      slider.value = video.currentTime;
      current.textContent = time(video.currentTime);
      duration.textContent = time(video.duration || 0);
      endCard.classList.toggle('is-visible', Number.isFinite(video.duration) && video.duration - video.currentTime <= 4);
    };
    play.addEventListener('click', () => video.paused ? video.play() : video.pause());
    mute.addEventListener('click', () => { video.muted = !video.muted; });
    slider.addEventListener('input', () => { video.currentTime = Number(slider.value); update(); });
    video.addEventListener('play', () => { play.textContent = 'Ⅱ'; play.setAttribute('aria-label', 'Pause video'); });
    video.addEventListener('pause', () => { play.textContent = '▶'; play.setAttribute('aria-label', 'Play video'); });
    video.addEventListener('volumechange', () => { mute.textContent = video.muted ? 'Muted' : 'Sound'; mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video'); });
    video.addEventListener('loadedmetadata', update);
    video.addEventListener('timeupdate', update);
  }
})();
